import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core";

export const styles = ({spacing, palette}: Theme) => createStyles({
    grid: {
        margin: 0,
        width: "100%"
    },
    item : {
        "&:first-child": {
            paddingLeft: 0
        },
        "&:last-child": {
            paddingRight: 0
        },
    },
    headline: {
        marginTop: spacing.unit * 4,
        marginBottom: spacing.unit,
    },
    text: {
        "& ul" : {
            paddingLeft: spacing.unit * 2,
            marginTop: 0
        },
        "& table" : {
            borderSpacing: 0,
            borderRadius: spacing.unit * 0.5,
            overflow: "hidden",
            boxShadow: "0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)"
        },
        "& tr:nth-of-type(even)" : {
            backgroundColor: palette.primary.light,
        },
        "& th" : {
            padding: spacing.unit,
            textAlign: "left",
            backgroundColor: palette.primary.main,
            color: palette.primary.contrastText
        },
        "& td" : {
            padding: spacing.unit,
            verticalAlign: "top",
            "&:first-child" : {
                borderRight: "1px solid #401c064f",
            },
        }
    },
    caption: {
        fontStyle: "italic"
    }

});


// WEBPACK FOOTER //
// ./src/components/Detail/Detail.style.tsx